<script setup lang="ts">
import { SecondaryButton } from '@/components/Buttons'
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import { GridLayout } from '@/components/Layouts'
import type { ActionModel } from '@/types/models/ActionModel'
import type { DeviceModel } from '@/types/models/DeviceModel'

type Props = {
    data?: DeviceModel[]
    actions?: ActionModel[]
}
defineProps<Props>()
</script>

<template>
    <InformationBaseCard class="full-width" :label="$t('device.detail.informations.actions')">
        <GridLayout :maxItemPerRow="2" :gap="8" class="full-width">
            <SecondaryButton
                v-for="(action, key) in actions"
                :key="key"
                :label="action.label"
                class="full-width"
                @click="action.cb" />
        </GridLayout>
    </InformationBaseCard>
</template>
